<main class="main">
  <h2 class="modalTitle" mat-dialog-title>
    {{ data.text }}
  </h2>
  <mat-dialog-content>
    <form [formGroup]="cancelForm">
      <mat-form-field>
        <mat-label>{{ 'reason' | i18next }}</mat-label>
        <textarea matInput type="text" formControlName="reason"></textarea>
      </mat-form-field>
    </form>
    <mat-dialog-actions class="modalBtnContainer">
      <div class="button-container">
        <button
          class="modalBtnContainer__btn btn cancel"
          type="button"
          mat-dialog-close
        >
          {{ 'btnNo' | i18next | uppercase }}
        </button>
        <button
          class="modalBtnContainer__btn btn"
          type="button"
          (click)="confirmCancel()"
          [disabled]="cancelForm.invalid"
          [ngStyle]="
            cancelForm.invalid
              ? { 'background-color': '#efffc1', 'font-weight': 'normal' }
              : { 'background-color': '#c8f546' }
          "
        >
          {{ 'btnYes' | i18next | uppercase }}
        </button>
      </div>
    </mat-dialog-actions>
  </mat-dialog-content>
</main>
